<template>
  <v-data-table
      :headers="tabla.headers"
      :items="tabla.items"
      :options.sync="tabla.options"
      :server-items-length="tabla.count"
      :fixed-header="true"
      class="elevation-3"
      calculate-widths
      :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
      :no-data-text="$t('No hay datos')"
      :no-results-text="$t('No hay datos')"
  >
    <template v-slot:item="{ item }">
      <tr :class="get_class(item)">
        <td>{{ item.fecha | moment('DD/MM/YYYY') }}</td>
        <td>{{ item.bono.text }}</td>
        <td>{{ item.fecha_caducidad | moment('DD/MM/YYYY') }}</td>
        <td>{{ item.limite_sesiones }}</td>
        <td>
          <div class="text-center">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" small color="primary">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item class="pointer" @click="$emit('on_click_ver_sesiones', item)">
                  <v-list-item-icon>
                    <v-icon>mdi-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("Ver sesiones") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="
                ($store.state.auth.user.is_superuser || $store.state.auth.user.tipo_empleado === 'admin')"
                             class="pointer" @click="$emit('on_click_edit', item)">
                  <v-list-item-icon>
                    <v-icon>mdi-star-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("Editar bono") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="!item.is_consumido && ($store.state.auth.user.is_superuser ||
                 $store.state.auth.user.tipo_empleado === 'admin')"
                             class="pointer" @click="$emit('on_click_deactivate', item)">
                  <v-list-item-icon>
                    <v-icon color="red">mdi-circle-off-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="red--text">{{ $t("Desactivar bono") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider v-if="!item.is_consumido && item.sesiones.length===0 && ($store.state.auth.user.is_superuser
                || ($store.state.auth.user.tipo_empleado === 'admin' && $store.state.centro.centro.country !== CONSTANTS.COUNTRY.SPAIN))"/>

                <v-list-item v-if="!item.is_consumido && item.sesiones.length===0 && $store.state.auth.user.is_superuser"
                             class="pointer" @click="$emit('on_click_delete', item)">
                  <v-list-item-icon>
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="red--text">{{ $t("Eliminar") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </td>
      </tr>
    </template>

  </v-data-table>
</template>

<script>

import useTable from "@/composables/useTable"
import CONSTANTS from "@/utils/constants";

export default {
  name: "TablaBonosVendidos",
  props: {
    selected_filters: {
      type: Object,
      default: {},
      required: true
    }
  },

  setup(props, {root}){
    const { tabla, get_items } = useTable('venta/get_bonos_vendidos')

    const get_bonos_vendidos = () => {

      let filtros = { ...tabla.filtros, ...props['selected_filters'] }

      get_items(filtros)
    }
    get_bonos_vendidos()

    /**
     * Devuelve la clase que corresponde a cada fila de la tabla
     * @param item
     * @returns {string}
     */
    const get_class = (item) => {
      if (item.is_consumido) {
        return "red--text text-decoration-line-through";
      }
      return ""
    }


    tabla.value.headers = [
      { text: root.$t('Fecha compra'), value: 'fecha', class: "primary white--text" },
      { text: root.$t('Nombre'), value: 'bono.text', class: "primary white--text" },
      { text: root.$t('Fecha caducidad'), value: 'fecha_caducidad', class: "primary white--text" },
      { text: root.$t('Límite sesiones'), value: 'limite_sesiones', class: "primary white--text" },
      { text: '', value: 'actions', class: "primary white--text", sortable: false, align: 'right', width: "80px" },
    ]

    return {
      CONSTANTS,
      tabla,
      get_bonos_vendidos,
      get_class
    }
  }
}
</script>
